/**
 * Characters on the split-flap drum, in physical order. A flap must rotate
 * through every character between its current and target position, so a
 * shorter drum means shorter flips.
 */
export const DEFAULT_ALPHABET = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.,!?-+:';

/**
 * Letters only - roughly 40% faster transitions than DEFAULT_ALPHABET.
 * Use for boards whose messages contain no digits or punctuation; any
 * character outside the drum renders as a blank.
 */
export const LETTERS_ALPHABET = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ';

/**
 * Board status enum
 */
export type BoardStatus = 'active' | 'draft' | 'archived';

/**
 * Board configuration
 */
export interface BoardConfig {
  rows: number;
  columns: number;
  rotationInterval?: number; // Seconds between message rotations
}

/**
 * Message with optional expiration
 */
export interface BoardMessage {
  id: string;
  text: string;
  align?: 'left' | 'center' | 'right';
  accentColor?: string | null;
  layout?: 'lines';
  expiresAt?: string; // ISO date string
  order: number;
}

/**
 * Board model
 */
export interface Board {
  id: string;
  public_id: string; // 6-character public identifier for sharing
  name: string;
  title?: string;
  status: BoardStatus;
  config: BoardConfig;
  messages: BoardMessage[];
  passcode?: string;
  soundEnabled?: boolean;
  hasPasscode?: boolean; // Indicates if board has a passcode (never exposes the hash)
  viewCount: number;
  createdAt: string;
  updatedAt: string;
}
